module.exports = __webpack_public_path__ + "img/bIndustry8.acaa6791.png";